import { Account, PayStatement } from "@wingspanhq/wingspan-api-sdk";

import { parsePayrollAmount } from "../../PayrollRuns/utils";
import { PaystubHistoryRow } from "../types";
import { formatPayerName } from "../utils";

type Input = {
  payStatement: PayStatement;
  /**
   * The paying company's account (`payStatement.payerAccountId`) — supplies the
   * employer name. The flat pay-statement read carries only the account id, so
   * the caller resolves the account separately and passes it here.
   */
  payerAccount?: Account;
};

/** Adapt a v3 `PayStatement` into a paystub history table row (payee perspective). */
export const selectorPaystubHistoryRow = ({
  payStatement,
  payerAccount
}: Input): PaystubHistoryRow => ({
  id: payStatement.id ?? "",
  date: payStatement.payPeriodEndDate,
  paidDate: payStatement.payDate,
  employerName: formatPayerName(payerAccount),
  netAmount: parsePayrollAmount(payStatement.amountDetails?.netPay),
  grossAmount: parsePayrollAmount(payStatement.amountDetails?.grossPay)
});
